import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline' | 'ghost';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-8 py-4 text-sm font-semibold tracking-wide transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-lime-500 rounded-lg';
  const variants = {
    primary: 'bg-gradient-to-r from-lime-400 to-lime-500 text-navy-900 hover:from-lime-500 hover:to-lime-600 shadow-lg hover:shadow-lime-500/25 border-none',
    outline: 'border-2 border-gold text-gold hover:bg-gold hover:text-white',
    ghost: 'text-gold hover:bg-gold/10'
  };
  const widthClass = fullWidth ? 'w-full' : '';
  return <button className={`${baseStyles} ${variants[variant]} ${widthClass} ${className}`} {...props} data-id="element-1">
      {children}
    </button>;
}